import { ActionsEnum } from "../enum/actions-enum";

export const updateLaudo = (value): any => ({
	type: ActionsEnum.UPDATE_LAUDO,
	laudoSession: value,
});

export const updateParams = (codigoLaudo: number, edicao: boolean, fromListaLaudos: boolean, tipoDeLaudo?: string): any => ({
	type: ActionsEnum.UPDATE_LAUDO_PARAMS,
	codigoLaudo,
	edicao,
	fromListaLaudos,
	tipoDeLaudo,
});

export const updateListLaudo = (value): any => ({
	type: ActionsEnum.UPDATE_LIST_LAUDO,
	newListLaudo: value,
});

export const updateMessage = (value): any => ({
	type: ActionsEnum.UPDATE_MESSAGE,
	message: value,
});

export const updateLaudoCompleto = (value): any => ({
	type: ActionsEnum.UPDATE_LAUDO_COMPLETO,
	newLaudoCompleto: value,
});
export const updateLaudoCompletoAlterado = (value): any => ({
	type: ActionsEnum.UPDATE_LAUDO_COMPLETO_EDICAO,
	newLaudoCompletoAlterado: value,
});

export const updateUsuarioLogado = (value): any => ({
	type: ActionsEnum.UPDATE_USUARIO_LOGADO,
	usuarioLogado: value,
});

export const updateFiltroLaudo = (value) => ({
	type: ActionsEnum.UPDATE_FILTRO_LAUDO,
	filtroLaudoSession: value,
});

export const updateIdentificacaoObraPreenchida = (value: boolean) => ({
	type: ActionsEnum.UPDATE_IDENTIFICACAO_OBRA_PREENCHIDA,
	identificacaoObraPreenchida: value,
});


export const updateMetodosProcedimentosPreenchidos = (value: boolean) => ({
	type: ActionsEnum.UPDATE_METODOS_PROCEDIMENTOS_PREENCHIDOS,
	metodosProcedimentosPreenchidos: value,
});

export const updateAtividadesExploradas = () => ({
	type: ActionsEnum.UPDATE_ATIVIDADES_EXPLORADAS,
});